import React from "react"
import PlasticsDescription from "../environment/en/PlasticsDescription"
import DisposalDescription from "../environment/en/DisposalDescription"
import NominationDescription from "../NominationLetterAccreditation/NominationDescription"
import NoObjectionLetterDescription from "../NoObjection/NoObjectionLetterDescription"
import DeliveryPartnerDescription from "../DeliveryPartner/DeliveryPartnerDescription"
import EnvironmentalAuditDescription from "../EnvironmentalAudit/EnvironmentalAuditDescription"

const Details = props => {
  if (props.type === "plastics") {
    return <PlasticsDescription />
  } else if (props.type === "disposal") {
    return <DisposalDescription />
  } else if (props.type === "accreditation") {
    return <NominationDescription />
  } else if (props.type === "no-objection") {
    return <NoObjectionLetterDescription />
  } else if (props.type === "delivery-partner") {
    return <DeliveryPartnerDescription />
  } else if (props.type === "environmental-audit") {
    return <EnvironmentalAuditDescription />
  } else {
    return <div></div>
  }
}

export default Details
